import { MenuItem } from '@mui/material';
import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { SMBSelect } from '../../../components';
import { getPunchlistTerritories } from '../../../fetch';
import { alphaSort } from '../../../helpers';
import { IPunchlistTerritory } from '../../../models';

interface IPunchlistTerritoryFilterProps {
  value: string | number;
  handleChange: (val: string | number) => void;
  isDisabled?: boolean;
  setOptions?: (val: any) => void;
  apiParams?: any;
}

export const PunchlistTerritoryFilter: FC<IPunchlistTerritoryFilterProps> = ({
  isDisabled,
  value,
  handleChange,
  setOptions,
  apiParams
}) => {
  const { isLoading: isLoadingTerritories, data: territoriesData } = useQuery<
    IPunchlistTerritory[],
    Error
  >(['territories-filters'], () => getPunchlistTerritories(), {
    staleTime: Infinity,
    cacheTime: 0,
    onSuccess: d => setOptions?.(d)
  });
  const territories = useMemo(() => territoriesData ?? [], [territoriesData]);
  return (
    <SMBSelect
      disabled={isDisabled || isLoadingTerritories}
      label={isLoadingTerritories ? 'Loading...' : 'Territory'}
      value={value}
      size="small"
      onChange={({ target: { value } }) => {
        handleChange(Number(value));
      }}
      handleClear={() => handleChange('')}
    >
      {!isLoadingTerritories && territories && territories.length === 0 && (
        <MenuItem disabled>No territories available</MenuItem>
      )}
      {!isLoadingTerritories &&
        territories &&
        alphaSort(territories, 'territoryName').map((territory, index) => {
          return (
            <MenuItem key={`${index}`} value={territory.territoryId}>
              {territory.territoryName}
            </MenuItem>
          );
        })}
    </SMBSelect>
  );
};
